import { ref } from 'vue'

const isDark = ref(false)

export function useTheme() {
  const setTheme = (dark) => {
    isDark.value = dark
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
    localStorage.setItem('omega-theme-v2', dark ? 'dark' : 'light')
  }

  const toggleTheme = () => setTheme(!isDark.value)

  const initTheme = () => {
    const saved = localStorage.getItem('omega-theme-v2')
    setTheme(saved ? saved === 'dark' : false)
  }

  return { isDark, toggleTheme, initTheme }
}
